/**
 * Festiwale Module
 * Obsługuje stronę festiwale.html:
 * - Animowane liczniki w hero
 * - Inicjalizacja mapy Leaflet z markerami
 * - Wyszukiwarka miast
 * - Generowanie kart wydarzeń
 */

(function () {
  'use strict';

  // ============================================
  // DANE WYDARZEŃ (z Figma)
  // ============================================
  var EVENTS_DATA = [
    // === JUWENALIA ===
    {
      name: 'Juwenalia Rzeszowskie',
      date: '08–09.05.2026',
      address: 'ul. Akademicka 1,\n35-084 Rzeszów',
      city: 'Rzeszów',
      lat: 50.0384,
      lng: 21.9990,
      category: 'juwenalia'
    },
    {
      name: 'Juwenalia Białostockie',
      date: '15–16.05.2026',
      address: 'ul. Wiejska 45A,\n15-351 Białystok',
      city: 'Białystok',
      lat: 53.1325,
      lng: 23.1688,
      category: 'juwenalia'
    },
    {
      name: 'Juwenalia Krakowskie',
      date: '20–23.05.2026',
      address: 'Strefa Plaża AGH\nul. Rostafińskiego 7a,\n30-072 Kraków',
      city: 'Kraków',
      lat: 50.0647,
      lng: 19.9450,
      category: 'juwenalia'
    },
    {
      name: 'Juwenalia Szczecińskie',
      date: '21–23.05.2026',
      address: 'Łasztownia\nul. Małgorzaty Wendy,\n70-655 Szczecin',
      city: 'Szczecin',
      lat: 53.4285,
      lng: 14.5528,
      category: 'juwenalia'
    },
    {
      name: 'Juwenalia Katowickie',
      date: '21–23.05.2026',
      address: 'Katowicki Park Leśny\nul. Francuska 180A,\n40-507 Katowice',
      city: 'Katowice',
      lat: 50.2599,
      lng: 19.0216,
      category: 'juwenalia'
    },
    {
      name: 'Juwenalia Gdynia',
      date: '29–30.05.2026',
      address: 'Molo Południowe\nal. Jana Pawła II,\n81-345 Gdynia',
      city: 'Gdynia',
      lat: 54.5189,
      lng: 18.5305,
      category: 'juwenalia'
    },

    // === FESTIWALE ===
    // {
    //   name: 'Target One Festival',
    //   date: '29–30.05.2026',
    //   address: 'Lotnisko Szymanów\nul. Lotnicza 1,\n55-114 Szymanów',
    //   city: 'Szymanów',
    //   lat: 51.1210,
    //   lng: 16.8140,
    //   category: 'festiwale'
    // },
    {
      name: 'Silesia Beats',
      date: '12–13.06.2026',
      address: 'Park Śląski\nAleja Różana 2,\n41-501 Chorzów',
      city: 'Chorzów',
      lat: 50.2745,
      lng: 18.9931,
      category: 'festiwale'
    },
    {
      name: 'Polish Hip-Hop Festival',
      date: '02–04.07.2026',
      address: 'Płock, plaża nad Wisłą\nul. Rybaki 9,\n09-401 Płock',
      city: 'Płock',
      lat: 52.5468,
      lng: 19.7064,
      category: 'festiwale'
    },
    {
      name: 'Clout Festival',
      date: '10–11.07.2026',
      address: 'Lotnisko Bemowo\nul. Piastów Śląskich 31,\n01-494 Warszawa',
      city: 'Warszawa',
      lat: 52.2297,
      lng: 20.9017,
      category: 'festiwale'
    },
    {
      name: 'Letnie Brzmienia Kraków',
      date: '24–25.07.2026',
      address: 'Lotnisko Rakowice-Czyżyny\nul. Skarżyńskiego 1,\n31-866 Kraków',
      city: 'Kraków',
      lat: 50.0771,
      lng: 20.0070,
      category: 'festiwale'
    },
    {
      name: 'Sunrise Festival',
      date: '31.07–02.08.2026',
      address: 'Lotnisko Kołobrzeg-Podczele (Bagicz),\n78-111 Kołobrzeg',
      city: 'Kołobrzeg',
      lat: 54.1784,
      lng: 15.5834,
      category: 'festiwale'
    },
    {
      name: 'Salt Wave',
      date: '31.07–01.08.2026',
      address: 'Lotnisko Jastarnia\nul. Adama Mickiewicza 170,\n84-140 Jastarnia',
      city: 'Jastarnia',
      lat: 54.6962,
      lng: 18.6739,
      category: 'festiwale'
    },
    {
      name: 'Letnie Brzmienia Warszawa',
      date: '07–08.08.2026',
      address: 'Tor Służewiec\nul. Puławska 266,\n02-684 Warszawa',
      city: 'Warszawa',
      lat: 52.16523303447461,
      lng: 21.01591217489338,
      category: 'festiwale'
    },
    {
      name: 'Rockowizna Gdańsk',
      date: '07–08.08.2026',
      address: 'ul. Pokoleń Lechii Gdańsk 1,\n80-560 Gdańsk',
      city: 'Gdańsk',
      lat: 54.3897713,
      lng: 18.6420479,
      category: 'festiwale'
    },
    {
      name: 'BitterSweet Festival',
      date: '13–15.08.2026',
      address: 'Park Cytadela\nal. Armii Poznań,\n61-704 Poznań',
      city: 'Poznań',
      lat: 52.4137,
      lng: 16.9425,
      category: 'festiwale'
    },
    {
      name: 'Rockowizna Poznań',
      date: '20–22.08.2026',
      address: 'Port Lotniczy Poznań Ławica\nul. Bukowska 285 (wejście od ul. Lotniczej),\n60-189 Poznań',
      city: 'Poznań',
      lat: 52.4205591,
      lng: 16.8310525,
      category: 'festiwale'
    },
    {
      name: 'Letnie Brzmienia Gdańsk',
      date: '21–22.08.2026',
      address: 'Plac Zebrań Ludowych,\n80-001 Gdańsk',
      city: 'Gdańsk',
      lat: 54.3520,
      lng: 18.6466,
      category: 'festiwale'
    },
    {
      name: 'Letnie Brzmienia Wrocław',
      date: '28–29.08.2026',
      address: 'Pola Marsowe\nal. Ignacego Jana Paderewskiego 35,\n51-612 Wrocław',
      city: 'Wrocław',
      lat: 51.1079,
      lng: 17.0385,
      category: 'festiwale'
    },
    {
      name: 'Rockowizna Kraków',
      date: '28–29.08.2026',
      address: 'Lotnisko Rakowice - Czyżyny\nAl. Jana Pawła II 39,\n31-864 Kraków',
      city: 'Kraków',
      lat: 50.0812529,
      lng: 19.9890285,
      category: 'festiwale'
    },
    {
      name: 'Letnie Brzmienia Poznań',
      date: '04–05.09.2026',
      address: 'Poznań',
      city: 'Poznań',
      lat: 52.4064,
      lng: 16.9252,
      category: 'festiwale'
    },
    {
      name: 'Jimek Bemowo',
      date: '12.09.2026',
      address: 'Lotnisko Bemowo\nul. Piastów Śląskich 31,\n01-494 Warszawa',
      city: 'Warszawa',
      lat: 52.2635808,
      lng: 20.9242383,
      category: 'festiwale'
    }
  ];

  // ============================================
  // SVG ICONS
  // ============================================
  var STORE_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M12.25 5.83v6.42H1.75V5.83" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.42 1.75H.58v4.08h12.84V1.75z" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.83 5.83v6.42M3.5 1.75v4.08M10.5 1.75v4.08" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var PIN_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M11 1.833C7.317 1.833 4.333 4.817 4.333 8.5c0 5.5 6.667 11.667 6.667 11.667s6.667-6.167 6.667-11.667c0-3.683-2.984-6.667-6.667-6.667z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="11" cy="8.5" r="2.333" stroke="#000" stroke-width="1.5"/></svg>';

  // ============================================
  // ANIMOWANE LICZNIKI
  // ============================================
  function initCounters() {
    var counters = document.querySelectorAll('[data-counter-target]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.5
    });

    counters.forEach(function (counter) {
      observer.observe(counter);
    });
  }

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-counter-target'), 10);
    var prefix = el.getAttribute('data-counter-prefix') || '';
    var valueEl = el.querySelector('.festivals-hero__counter-value');
    if (!valueEl) return;

    var duration = 2000; // 2s
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // Ease-out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      valueEl.textContent = prefix + current;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        valueEl.textContent = prefix + target;
      }
    }

    requestAnimationFrame(step);
  }

  // ============================================
  // GENEROWANIE KART WYDARZEŃ
  // ============================================
  function generateEventCards() {
    var juwenaliaGrid = document.getElementById('juwenalia-grid');
    var festiwaleGrid = document.getElementById('festiwale-grid');

    if (!juwenaliaGrid || !festiwaleGrid) return;

    EVENTS_DATA.forEach(function (event) {
      var card = createEventCard(event);
      if (event.category === 'juwenalia') {
        juwenaliaGrid.appendChild(card);
      } else {
        festiwaleGrid.appendChild(card);
      }
    });
  }

  function createEventCard(event) {
    var card = document.createElement('div');
    card.className = 'festivals-card js-reveal js-reveal--slow';

    var addressLines = event.address.replace(/\n/g, '<br>');
    var googleMapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(event.lat + ',' + event.lng);

    card.innerHTML =
      '<div class="festivals-card__header">' +
      '<div class="festivals-card__title-row">' +
      '<div class="festivals-card__icon">' + STORE_ICON_SVG + '</div>' +
      '<p class="festivals-card__name">' + event.name + '</p>' +
      '</div>' +
      '<p class="festivals-card__date">' + event.date + '</p>' +
      '</div>' +
      '<div class="festivals-card__address-section">' +
      '<p class="festivals-card__address-label">Adres</p>' +
      '<p class="festivals-card__address">' + addressLines + '</p>' +
      '</div>' +
      '<a href="' + googleMapsUrl + '" target="_blank" rel="noopener noreferrer" class="festivals-card__route">' +
      PIN_ICON_SVG +
      'Wyznacz trasę' +
      '</a>';

    return card;
  }

  // ============================================
  // MAPA LEAFLET
  // ============================================
  var map = null;
  var markers = [];

  function initMap() {
    var container = document.getElementById('map-container');
    if (!container || typeof L === 'undefined') return;

    // Inicjalizacja mapy — centrowana na Polskę
    map = L.map('map-container', {
      scrollWheelZoom: false,
      attributionControl: true
    }).setView([52.0, 19.5], 6);

    // CartoDB Positron — jasny styl mapy pasujący do Figma
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap',
      // subdomains: 'abcd',
      maxZoom: 26
    }).addTo(map);

    // Custom Camel marker icon
    var camelIcon = L.divIcon({
      className: 'festivals-map-marker',
      html: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42" fill="none"><path d="M16 0C7.163 0 0 7.163 0 16c0 12 16 26 16 26s16-14 16-26C32 7.163 24.837 0 16 0z" fill="#006CFF"/><circle cx="16" cy="16" r="6" fill="white"/></svg>',
      iconSize: [32, 42],
      iconAnchor: [16, 42],
      popupAnchor: [0, -42]
    });

    // Dodaj markery
    EVENTS_DATA.forEach(function (event) {
      if (!event.lat || !event.lng) return;

      var addressLines = event.address.replace(/\n/g, '<br>');
      var googleMapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' +
        encodeURIComponent(event.lat + ',' + event.lng);

      var popupContent =
        '<div class="map-popup">' +
        '<div class="map-popup__header">' +
        '<div class="map-popup__icon">' + STORE_ICON_SVG + '</div>' +
        '<p class="map-popup__name">' + event.name + '</p>' +
        '</div>' +
        '<p class="map-popup__date">' + event.date + '</p>' +
        '<div>' +
        '<p class="map-popup__address-label">Adres</p>' +
        '<p class="map-popup__address">' + addressLines + '</p>' +
        '</div>' +
        '<a href="' + googleMapsUrl + '" target="_blank" rel="noopener noreferrer" class="map-popup__route">' +
        PIN_ICON_SVG +
        'Wyznacz trasę' +
        '</a>' +
        '</div>';

      var marker = L.marker([event.lat, event.lng], { icon: camelIcon })
        .addTo(map)
        .bindPopup(popupContent, { maxWidth: 320, closeButton: true });

      marker._eventData = event;
      markers.push(marker);
    });
  }

  // ============================================
  // WYSZUKIWARKA MIAST
  // ============================================
  function initCitySearch() {
    var searchField = document.getElementById('festivals-city-search');
    var resultsList = document.getElementById('festivals-search-results');
    var searchWrapper = searchField ? searchField.closest('.festivals-map__search') : null;

    if (!searchField || !resultsList || !searchWrapper) return;

    var chevron = searchWrapper.querySelector('.festivals-map__search-chevron');

    // Zbierz unikalne miasta
    var cities = [];
    var citySet = {};
    EVENTS_DATA.forEach(function (event) {
      if (event.city && !citySet[event.city]) {
        citySet[event.city] = true;
        cities.push(event.city);
      }
    });
    cities.sort();

    // Pokaż/ukryj wyniki
    searchField.addEventListener('focus', function () {
      filterCities('');
      searchWrapper.classList.add('is-open');
    });

    searchField.addEventListener('input', function () {
      filterCities(this.value);
      searchWrapper.classList.add('is-open');
    });

    // Chevron toggle — kliknięcie otwiera/zamyka listę
    if (chevron) {
      chevron.style.cursor = 'pointer';
      chevron.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (searchWrapper.classList.contains('is-open')) {
          searchWrapper.classList.remove('is-open');
        } else {
          filterCities(searchField.value);
          searchWrapper.classList.add('is-open');
          searchField.focus();
        }
      });
    }

    // Zamknij po kliknięciu poza
    document.addEventListener('click', function (e) {
      if (!searchWrapper.contains(e.target)) {
        searchWrapper.classList.remove('is-open');
      }
    });

    function filterCities(query) {
      resultsList.innerHTML = '';
      var q = query.toLowerCase().trim();
      var filtered = cities.filter(function (city) {
        return !q || city.toLowerCase().indexOf(q) !== -1;
      });

      filtered.forEach(function (city) {
        var li = document.createElement('li');
        li.textContent = city;
        li.addEventListener('click', function () {
          searchField.value = city;
          searchWrapper.classList.remove('is-open');
          flyToCity(city);
        });
        resultsList.appendChild(li);
      });
    }

    function flyToCity(city) {
      if (!map) return;

      // Znajdź event w danym mieście
      var found = null;
      for (var i = 0; i < EVENTS_DATA.length; i++) {
        if (EVENTS_DATA[i].city === city) {
          found = EVENTS_DATA[i];
          break;
        }
      }

      if (found && found.lat && found.lng) {
        map.flyTo([found.lat, found.lng], 12, { duration: 1.5 });

        // Otwórz popup pierwszego markera w tym mieście
        markers.forEach(function (marker) {
          if (marker._eventData && marker._eventData.city === city) {
            setTimeout(function () {
              marker.openPopup();
            }, 1600);
          }
        });
      }
    }
  }

  // ============================================
  // CUSTOM MARKER STYLES (injected CSS)
  // ============================================
  function injectMarkerStyles() {
    var style = document.createElement('style');
    style.textContent =
      '.festivals-map-marker { background: none !important; border: none !important; }' +
      '.festivals-map-marker svg { filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3)); transition: transform 0.2s ease; }' +
      '.festivals-map-marker:hover svg { transform: scale(1.15); }';
    document.head.appendChild(style);
  }

  // ============================================
  // INIT
  // ============================================
  function init() {
    if (!document.querySelector('.page-festiwale')) return;

    injectMarkerStyles();
    generateEventCards();
    initCounters();
    initMap();
    initCitySearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
